import type {CellAddress} from '../types'

/**
 * A cell is addressed by a `{columnKey, rowKey}` pair everywhere it is passed around.
 * A few places downstream need one string instead: a drag node id, an option value in
 * the move dialog, an overlay owner id. This is the only place either half is
 * joined.
 *
 * Column and row keys are opaque and may contain any character, so a bare join
 * collides, and a collision means two cells sharing one identity. Length-prefixing each
 * half makes the composition injective.
 *
 * The result is never parsed back: every consumer that needs the halves already holds
 * the `CellAddress`.
 */
export function composeCellKey({columnKey, rowKey}: CellAddress): string {
  return `${columnKey.length}:${columnKey}:${rowKey.length}:${rowKey}`
}
